import axios from '@axios'

/** 
* Índice
* {@link getTeachers} - Obtener profesorado
*/

    /**
     * Obtener todo el profesorado
     * @param {*} queryParams 
     * @returns teachers 
     */
    export const getTeachers = function (queryParams) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get('/teachers', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

  